import ExpenseTrash from "./components/ExpenseTrash";

export default ExpenseTrash;
